function encode(data) {
	return data
		.map((pair) => encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]))
		.join('&')
}

export const netlifyFormHandle = (e) => {
	e.preventDefault();
	const form = e.currentTarget;
	const formData = new FormData(form);
	return fetch(form.action, {
		method: 'POST',
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		body: encode([
			['form-name', form.getAttribute('name')],
			...formData.entries(),
		]),
	}).then((response) => {
		if (!response.ok) {
			throw new Error(`Form submission failed with status ${response.status}`);
		}
		return response;
	});
}
